import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../ui/accordion';

const faqs = [
  { q: 'How quickly can you respond to service calls?', a: 'We aim to respond within 24 hours for standard service calls. For emergency situations, we prioritize immediate response within the Ballito and North Coast area.' },
  { q: 'Do you service both residential and commercial systems?', a: 'Yes, we specialize in both residential air conditioning and refrigeration, as well as light commercial systems including cold rooms and commercial fridges.' },
  { q: 'What brands of air conditioners do you service?', a: 'We service all major air conditioning brands including Daikin, Mitsubishi, LG, Samsung, Carrier, TCL, Midea, Hisense and more. Our technician is trained across multiple systems.' },
  { q: 'How often should my air conditioner be serviced?', a: 'We recommend servicing your air conditioner at least once a year, ideally before summer. Regular maintenance prevents breakdowns and improves efficiency.' },
  { q: 'Do you offer warranties on your work?', a: 'Yes, we provide warranties on both parts and labor. Specific warranty terms depend on the type of service or repair performed.' },
  { q: 'What payment methods do you accept?', a: 'We accept cash, EFT, and card payments. Payment terms will be discussed during your service call.' },
];

export const FAQ = () => {
  return (
    <section id="faq" data-testid="faq-section" className="py-20 bg-[#0D1233]">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <span className="inline-block bg-[#0066FF]/20 text-[#00D9FF] px-5 py-2 rounded-full text-sm font-bold uppercase tracking-wider mb-4">
            FAQ
          </span>
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            Frequently Asked Questions
          </h2>
          <p className="text-base md:text-lg text-gray-400">
            Find answers to common questions about our services
          </p>
        </div>
        <div className="max-w-3xl mx-auto">
          <Accordion type="single" collapsible className="space-y-4">
            {faqs.map((faq, i) => (
              <AccordionItem key={i} value={`item-${i}`} className="bg-white/5 border border-white/10 rounded-lg px-6 data-[state=open]:border-[#00D9FF]/30">
                <AccordionTrigger className="text-left font-semibold text-white hover:text-[#00D9FF] text-sm md:text-base">
                  {faq.q}
                </AccordionTrigger>
                <AccordionContent className="text-gray-400 leading-relaxed text-sm">
                  {faq.a}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </div>
      </div>
    </section>
  );
};
